import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {environment} from '../../../environments/environment';
import {DeviceDetectorService} from 'ngx-device-detector';
import {FlowTypeService} from '../../../../../shared/src/lib/services/flow-type.service';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements OnInit {

    testName = 'anxiety';

    uid;

    startTextButtonText = 'Start test';
    apiUrl = environment.apiUrl;

    isItForMeItems = [
        {
            title: 'Іntense stress',
            link: 'https://blog.anima.help/intense-stress-friend-or-foe/',
            img: 'img-1.png'
        },
        {
            title: 'Traumatic event',
            link: 'https://blog.anima.help/trauma-may-be-closer-than-you-think/',
            img: 'img-2.png'
        },
        {
            title: 'Therapy client/<br/>patient',
            link: 'https://blog.anima.help/helping-you-to-track-progress/',
            img: 'img-3.png'

        },
        {
            title: 'Therapist',
            link: 'https://blog.anima.help/how-to-measure-the-effectiveness-of-the-therapy/',
            img: 'img-4.png'
        }
    ];

    videoSrc = 'assets/img/animation/a_brain.webm';

    constructor(
        private router: Router,
        public auth: AuthService,
        private device: DeviceDetectorService,
        private flowTypeService: FlowTypeService
    ) {
    }

    ngOnInit() {
        this.flowTypeService.state = 'default';

        if (this.device.browser.toLowerCase() === 'safari') {
            this.videoSrc = null;
        }
        this.startTextButtonText = this.auth?.userState?.trial ? 'Free trial' : 'Start test';
    }

    goToLink(url: string) {
        window.open(url, '_blank');
    }

    void(event: any) {
        event.preventDefault();
    }

    onPlansLoaded(prop: any) {
        // if (window.location.hash) {
        //     this.scrollToFirstInvalidControl(window.location.hash);
        // }
    }

    scrollToFirstInvalidControl(prop) {
        const el: HTMLElement = document.getElementById(prop.split('#')[1]);
        this.scroll(el, 0);
    }

    scroll(controlEl: HTMLElement, top: number) {
        controlEl.scroll({
            top: 0,
            left: 0,
            behavior: 'auto'
        });
    }

    async goToTest() {
        return this.router.navigate(
            ['cs'],
            {
                state: {
                    name: this.testName
                }
            });
    }

    onPaymentSuccess(prop) {

        if (prop) {
            this.goToTest().then();
        }
    }
}
